import { render, staticRenderFns } from "./number-value-view.vue?vue&type=template&id=562acb0c&"
import script from "./number-value-view.vue?vue&type=script&lang=ts&"
export * from "./number-value-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports